export default [
    'AVERAGE_VELOCITY',
    'PEAK_VELOCITY',
    // 'ROM',
    // 'PEAK_HEIGHT',
    // 'DURATION',
];
